import { render, staticRenderFns } from "./PrReceipt.vue?vue&type=template&id=75524986&scoped=true&"
import script from "./PrReceipt.vue?vue&type=script&lang=js&"
export * from "./PrReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75524986",
  null
  
)

export default component.exports